import React from 'react';
import { Route, Redirect, Switch } from 'react-router-dom';
import async from '@xanadu/ui-shared/components/asyncComponent';

import GlobalBannerPortal from '@xanadu/ui-shared/components/GlobalBannerPortal';

const AsyncReports = async(() =>
  import('../containers/reports/Reports/Reports').then(module => module.default)
);

const AsyncAccountActivity = async(() =>
  import('../containers/AccountActivity').then(module => module.default)
);

const AsyncTransactions = async(() =>
  import('../containers/reports/Transactions').then(module => module.default)
);

const AsyncSettled = async(() =>
  import('../containers/reports/Settled').then(module => module.default)
);

const AsyncMultiples = async(() =>
  import('../containers/reports/Multiples').then(module => module.default)
);

const AsyncBetBuilder = async(() =>
  import('../containers/reports/BetBuilder').then(module => module.default)
);

const AsyncCurrent = async(() =>
  import('../containers/reports/Current').then(module => module.default)
);


export default function () {
  return (
    <React.Fragment>
      <GlobalBannerPortal bigger />
      <Route path="/reports">
        <Switch>
          <Redirect exact from="/reports/" to="/reports/settled/bets" />
          <Redirect exact from="/reports/current" to="/reports/current/bets" />
          <Redirect exact from="/reports/settled" to="/reports/settled/bets" />
          <Redirect exact from="/reports/accas" to="/reports/multiples" />
          <AsyncReports>
            <Route
              path="/reports/account-activity"
              component={AsyncAccountActivity}
            />
            <Route
              path="/reports/transaction-history"
              component={AsyncTransactions}
            />
            <Route
              path="/reports/settled/bets"
              render={() => (
                <AsyncSettled />
              )}
            />
            <Route
              path="/reports/multiples"
              render={() => (
                <AsyncMultiples />
              )}
            />
            <Route
              path="/reports/bet-builder"
              render={() => (
                <AsyncBetBuilder />
              )}
            />
            <Route
              path="/reports/current/bets"
              render={() => (
                <AsyncCurrent type="bets" />
              )}
            />
            <Route
              path="/reports/current/offers"
              render={() => (
                <AsyncCurrent type="offers" />
              )}
            />
          </AsyncReports>
        </Switch>
      </Route>
    </React.Fragment>
  );
}
